import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatMetric = createCustomElementWrapper('kat-metric', 'KatMetric', {
    'headerClickable': 'header-clickable',
    'trendPolarity': 'trend-polarity',
    'trendValue': 'trend-value',
}, {
    'onClicked': 'clicked',
}, [
    'control',
    'actions',
    'amount',
    'visualization',
]);
